module.exports = __webpack_public_path__ + "media/images/logo/vzvz-37fed7d0e8be536f953a33c49e12812f.png";